import ReactDOM from 'react-dom/client';

export function handleGenericEdit(id, elementToRender) {
  const container = document.getElementById(id);
  if (container) {
    const root = ReactDOM.createRoot(container);
    root.render(elementToRender);
  }
}

export function handleGenericSubmit(
  textEditorSelector,
  editableRef,
  containerId,
  elementToRender,
  postMode = false
) {
  // create the container
  const container = document.createElement('div');
  container.id = containerId;
  container.contentEditable = 'false';
  container.dataset.atomic = 'true';

  const editor = editableRef.current;

  // Guarantee an editable line exists before atomic blocks inserted at the top.
  const ensureTopSpacer = () => {
    if (!editor || !editor.contains(container)) return null;

    const resolveRootChild = () => {
      let node = container;
      while (node.parentNode && node.parentNode !== editor) {
        node = node.parentNode;
      }
      return node.parentNode === editor ? node : null;
    };

    const rootChild = resolveRootChild();
    if (!rootChild) return null;

    const hasContentBefore = () => {
      let current = rootChild.previousSibling;
      while (current) {
        if (current.nodeType === Node.TEXT_NODE && current.textContent.trim()) {
          return true;
        }
        if (
          current.nodeType === Node.ELEMENT_NODE &&
          current.dataset?.placeholderBlock !== 'true'
        ) {
          return true;
        }
        current = current.previousSibling;
      }
      return false;
    };

    if (hasContentBefore()) return null;

    let spacer = Array.from(editor.childNodes).find(
      node =>
        node.nodeType === Node.ELEMENT_NODE &&
        node.dataset?.placeholderBlock === 'true'
    );

    if (spacer) {
      if (spacer.parentNode !== editor) {
        spacer.parentNode?.removeChild(spacer);
        editor.insertBefore(spacer, rootChild);
      } else if (spacer.nextSibling !== rootChild) {
        editor.insertBefore(spacer, rootChild);
      }
      return spacer;
    }

    spacer = editor.ownerDocument.createElement('div');
    spacer.dataset.placeholderBlock = 'true';
    spacer.className = 'add-post__article-top-spacer';
    spacer.setAttribute('contenteditable', 'true');
    spacer.innerHTML = '<br />';
    editor.insertBefore(spacer, rootChild);
    return spacer;
  };

  const focusTopSpacer = (spacer) => {
    if (!spacer || !editor || !editor.contains(spacer)) return;
    editor.focus();
    const range = editor.ownerDocument.createRange();
    range.selectNodeContents(spacer);
    range.collapse(true);
    const selection = editor.ownerDocument.getSelection();
    if (!selection) return;
    selection.removeAllRanges();
    selection.addRange(range);
  };

  // If postMode is true we insert it at the beginning
  // specially for the post artworks/pictures
  if (postMode && editor) {
    if (editor.firstChild) {
      editor.insertBefore(container, editor.firstChild);
    } else {
      editor.appendChild(container);
    }
  } else if (textEditorSelector) {
    const range = textEditorSelector;
    // Ensure the selection is inside the editor
    if (editor.contains(range.startContainer)) {
      // Insert the container at the cursor position
      range.collapse(false); // collapse to end of selection
      range.insertNode(container);
      // Optionally, move the cursor after the inserted node
      range.setStartAfter(container);
      range.setEndAfter(container);
      // we set the cursor selection where it was
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(textEditorSelector);
    } else {
      // fallback: append to end
      editor.appendChild(container);
    }
  } else {
    // fallback: append to end
    editor.appendChild(container);
  }

  const spacer = ensureTopSpacer();
  focusTopSpacer(spacer);

  // mount the React preview
  const root = ReactDOM.createRoot(container);
  root.render(elementToRender);

  // we ensure we have a final line break
  // Append the <span key="to-type" id='to-type'><br/></span> after the container
  // Create the span element
  const toTypeSpan = document.createElement('span');
  toTypeSpan.setAttribute('id', 'to-type');
  // key is not a DOM attribute, so it's ignored in the DOM
  toTypeSpan.innerHTML = '<br/>';

  // Insert after the container
  if (container.nextSibling) {
    container.parentNode.insertBefore(toTypeSpan, container.nextSibling);
  } else {
    container.parentNode.appendChild(toTypeSpan);
  }
}
